export const lang = {
  companyName: 'NESC',
  /* 首页 */
  home: 'Home',

  /* 关于我们 */
  about: 'About Us',
  corporateCulture: 'Corporate Culture',
  companyProfile: 'Company Profile',
  developmentHistory: 'Development History',
  productionOffice: 'Production Office',
  cellProductionLine: 'Cell Production Line',

  /* 产品系列 */
  productGroup: 'Products',
  highRateCell: 'High Rate BatteryCell',
  batteryModule: 'Battery Module',

  /* 解决方案 */
  solutions: 'Solutions',
  heavyTransport: 'Heavy Transport',
  logisticsFreight: 'Logistics Freight',
  cityDelivery: 'City Delivery',
  lightPassengerVehicle: 'Light Passenger Vehicle',
  highSpeedMotorcycle: 'HighSpeed Electric Motorcycle',
  electricalTools: 'Electrical Tools',
  drone: 'Drone',

  /* 创新技术 */
  technology: 'R&D',
  materialTechnology: 'Material Technology',
  structuralTechnology: 'Structural Technology',
  cloudPlatform: 'Safety Technology',

  /* 新闻 */
  news: 'News',

  /* 联系我们 */
  contactUs: 'Contact Us',
  talentRecruitment: 'Talent Recruitment',
  channelCooperation: 'Channel Cooperation',
  bidAnnouncement: 'Bid Announcement',

  privacyPolicyInformationSecurity: 'Privacy and Information Security',
  legalNote: 'Legal',

  homeText: "Build a new scene of super fast charging",
  homeText1: "Charging like refueling",


  newsTitle: 'News',
  checkMore: 'Check More',

  vision: 'Vision',
  visionContent: 'Drive the world\'s energy transformation with ultra-electric power',
  mission: 'Mission',
  missionContent: "Keep Innovation for unlimited energy of users",
  coreValue: 'Core Value',
  coreValueContent: 'Innovation &nbsp; Excellence &nbsp; Integrity &nbsp; Win',
  companyProfileContent: 'Jiangsu ChaoDian Technology Development Co., Ltd. is determined to become the world\'s leading battery R&D and intelligent manufacturing enterprise. Since its establishment in 2015, it has been focusing on creating super fast charging batteries, providing minute-level super fast charging batteries and application solutions for various industries such as engineering heavy trucks, urban logistics, light electric power, and home appliances. An operating minute-level super fast charging system solution provider.',
  historyList2015: 'Jiangsu ChaoDian Technology Development Co., Ltd was established in Wuxi',
  historyList2016: 'Angel round financing',
  historyList2017: 'Established Shandong ChaoDian to invest in a new 3.5GWh production line',
  historyList2018: 'Super fast charging industry application demonstration nationwide promotion',
  historyList2021: 'The first phase of Shandong production line was completed and put into operation and the second phase of production line planning and design',
  historyList2022: 'The production line planning of the five major production areas in the country and the second phase of the Shandong production line were completed and put into operation',

  previous:'Prev',
  next: 'Next',

  loopLife: 'Cycle Life',
  energyDensity: 'Energy Density',
  workTemp: 'Working Temp',
  standardVol: 'Standard Vol',
  chargeRate: 'Charge Rate',
  dischargeRate: 'Discharge Rate',

  platformDevelop: 'Platform Develop',
  moduleFreeSet: 'Modules Free Configure',
  highRate: 'Ultra High Magnification',
  highHengLiu: 'Ultra High Constant Current Rate',
  highLoopLife: 'Long Cycle Life',
  highTempRange: 'Wide Charging Temperature Range',
  highPower: 'High Energy Density',

  heavyCarContent: 'ChaoDian power battery provides surging power for heavy-duty transportation vehicles, meet the needs of various complex working conditions such as construction sites, mines, ports, and road engineering construction, greatly save charging time, reduce unit use costs, improve operational efficiency, and reduce fuel carbon. Emissions provides practical solutions for efficient application scenarios.',
  huoCheContent: 'ChaoDian power battery products have the characteristics of high safety, long life, strong environmental adaptation, etc., covering pure electric vans, electric cleaning vehicles, electric cleaning vehicles, electric garbage collection and transportation vehicles and other freight models, with zero pollution and zero emissions.',
  sanLunContent: 'ChaoDian provides green, intelligent and safe super fast charging system application solutions for electric two-wheelers and tricycles.',
  chenYongContent: 'ChaoDian continues to innovate by providing single cells with super fast charging, ultra-high energy ratio, ultra-high power ratio, and ultra-long life for passenger cars, as well as battery pack design and energy system storage efficiency, etc. Come on!", truly realizing worry-free battery life.',
  elecMoContent: 'Through the revolutionary super fast charging technology, flexible cell configuration scheme and intelligent BMS super fast charging management strategy, ChaoDian enables high-speed electric motorcycle customers to enjoy the same acceleration, battery life and durability as world-class brands while enjoying global Leading super fast charging and super safe.',
  elecContent: 'According to the needs of power tools in metal cutting, grinding, assembly, railway and garden application scenarios, ChaoDian provides battery product solutions with fast charging, wide temperature resistance, long life and strong power.',
  wuRenJiContent: 'Through the revolutionary super fast charging and intelligent control technology, ChaoDian brings an effective spraying load of 40 kg and a spreading load of 50 kg, creating a new benchmark for efficient, convenient and intelligent agriculture.',

  channelInvestment: 'Channel Investment',
  businessCooperation: 'Business Cooperation',
  contactInformation: "Contact Info",
  ext: "ext.",
  contact: 'contact',
  yuChao: 'Mr.Yu',
  caoYanJiang: 'Mr.Cao',

  zhaoPinTitle1: 'Working at ChaoDian makes a big difference',
  zhaoPinTitle2: 'Make exciting products together',
  zhaoPinTitle3:'Do things with smart people',

  zhaoPinContent1: 'At ChaoDian, the working atmosphere allows everyone to actively innovate and work hard for good things. There is no hierarchy of big companies here, and everyone can come up with their own ideas and ideas at any time.',
  zhaoPinContent2: 'Let everyone enjoy the fun of technology. ChaoDian has launched the world\'s first mobile power supply that can be fully charged in 800 seconds - ChaoDianbao, establishing the leading position of graphene application in the field of mobile power!',
  zhaoPinContent3:'ChaoDian has a first-class Internet talent gene. In May 2015, it invested and established Jiangsu ChaoDian New Energy to provide energy system integration solutions and technical support services for customers in the fields of industry, military and consumer goods.',

  joinUs: 'Join Us',
  jobTitle: 'Job Title',
  jobCategories: 'Job Categories',
  numberOfRecruits: 'Number Of Recruits',
  workPlace: 'Work Place',
  releaseDate: 'Release Date',
  more: 'More',
  operate: 'Operate',
  check: 'Details',

  recruitment: 'Recruitment',
  monthlySalary: 'Monthly Salary',
  descriptionOfJob: 'Job Description',
  workContent: 'Work Content',
  companyBenefits: 'Company Benefits',
  jobRequirements: 'Job Requirements',

  address: "Address",
  phone: "Tel",
  email: "Email",
  choseLanguage: 'Language'
}
